<!--
  --
  -- 組織のページヘッダ コンポーネント
  --
  -->
<template>
  <v-app-bar
    app :dark="dark" color="appbar"
  >
    <c-title />
    <v-spacer />

    <!-- トップページへのリンク（モバイル） -->
    <template v-if="$vuetify.breakpoint.xsOnly">
      <a :href="rootRoute"><v-btn icon color="primary"><v-icon>home</v-icon></v-btn></a>
    </template>

    <!-- トップページへのリンク（PC) -->
    <template v-else>
      <a :href="rootRoute"><v-btn color="primary">トップページ</v-btn></a>
    </template>

    <template v-if="!noActions">
      <component :is="actions"/>
    </template>

    <template
      v-if="navs.length > 0"
      #extension
    >
      <c-nav :links="navs"/>
    </template>
  </v-app-bar>
</template>

<script>
import CTitle from './CTitle'
import CLoginNav from './CLoginNav'
import CUserMenu from './CUserMenu'
import CNav from './CNav'

export default {
  name: 'CHeader',
  components: {
    CTitle,
    CNav
  },
  props: {
    // アクションコンポーネントを表示するか
    noActions: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    /**
     * ページヘッダの背景色が暗い色か
     */
    dark () {
      return this.isDarkColor('appbar')
    },

    /**
     * ナビゲーションリンクのリスト
     */
    navs () {
      return this.getters['org/navs']
    },

    /**
     * ログインしているか
     */
    authed () {
      return this.getters['user/authed']
    },

    /**
     * 表示するアクションコンポーネント
     */
    actions () {
      return this.authed ? CUserMenu : CLoginNav
    },

    /**
     * トップページボタン
     */
    rootRoute () {
      // return this.getters['org/topRoute']
      return this.getters['org/topURL']
    }
  }
}
</script>
